// extracted by mini-css-extract-plugin
module.exports = {"emptyState":"_25AND","primaryText":"_2rx24","secondaryText":"_2Wj2Q"};